import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import Typography from "@mui/material/Typography"
import { useTheme } from "@mui/material/styles"

import DialogHeader from "../components/DialogHeader"
import { SIDEBAR_WIDTH_COLLAPSED } from "../components/SidebarLinks"
import {
  CAMPAIGN_SCRIPT_PREVIEW_SX,
  sanitizePreviewHtml,
} from "./campaignScriptConstants"

export default function CampaignScriptPreviewDialog({
  open,
  onClose,
  content,
  inCall = false,
}) {
  const theme = useTheme()
  const hasContent = Boolean((content || "").replace(/<[^>]+>/g, "").trim())

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      scroll="paper"
      hideBackdrop={inCall}
      disableEnforceFocus={inCall}
      disableAutoFocus={inCall}
      disableRestoreFocus={inCall}
      disableScrollLock={inCall}
      sx={
        inCall
          ? {
              zIndex: 1120,
              pointerEvents: "none",
              "& .MuiDialog-container": {
                alignItems: "stretch",
                justifyContent: "flex-start",
                pt: 2,
                pl: { xs: 1, sm: `calc(${SIDEBAR_WIDTH_COLLAPSED} + 16px)` },
                pr: "calc(var(--power-dialer-sidebar-width, 0px) + 16px)",
                pb: "168px",
              },
            }
          : undefined
      }
      PaperProps={{
        sx: inCall
          ? {
              width: "100%",
              maxWidth: "none",
              height: "100%",
              maxHeight: "100%",
              m: 0,
              pointerEvents: "auto",
              border: "3px solid",
              borderColor: "error.main",
              boxShadow: "0 0 0 1px rgba(217, 45, 32, 0.2)",
            }
          : {
              width: "calc(100vw - 32px)",
              maxWidth: 1440,
              height: "92vh",
              maxHeight: "92vh",
              m: { xs: 1, sm: 2 },
              pointerEvents: "auto",
            },
      }}
    >
      <DialogHeader
        title={inCall ? "Campaign Script" : "Script preview"}
        onClose={onClose}
      />
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
          overflow: "hidden",
        }}
      >
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {inCall
            ? "Read this script while you are on the call. Mute, keypad, and hang up stay in the call widget."
            : "This is how the caller or team will see the script. Editing is disabled in preview."}
        </Typography>
        {hasContent ? (
          <Typography
            component="div"
            sx={{
              flex: 1,
              minHeight: 0,
              border: `1px solid ${theme.palette.divider}`,
              borderRadius: 2,
              p: { xs: 1.5, sm: inCall ? 1.75 : 2.5 },
              bgcolor: "background.paper",
              overflow: "auto",
              "& img": { maxWidth: "100%", height: "auto" },
              "& a": { color: theme.palette.colors?.brand500 },
              ...CAMPAIGN_SCRIPT_PREVIEW_SX,
            }}
            dangerouslySetInnerHTML={{ __html: sanitizePreviewHtml(content) }}
          />
        ) : (
          <Typography variant="body2" color="text.secondary">
            No campaign script has been added yet.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={{ textTransform: "none" }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}
